import { render } from "./group-builder.vue?vue&type=template&id=55927843&scoped=true"
import script from "./group-builder.vue?vue&type=script&lang=js"
export * from "./group-builder.vue?vue&type=script&lang=js"

import "./group-builder.vue?vue&type=style&index=0&id=55927843&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55927843"]])

export default __exports__